// extracted by mini-css-extract-plugin
export default {"container":"NoPermission__container--6v0PP","content":"NoPermission__content--HLPMR","guideImg":"NoPermission__guideImg--yxmvu"};